export class MtmaExportData {
    Type: string;
    Name: string;
    Description: string;
    Phone: string;
    KeyboardCode: string; // UnitCode
    Code: string; // KeypadTagCode
    Action1: string;
    Action2: string;
    RuleName: string;
    Contact1Name: string;
    Contact2Name: string;
    Contact3Name: string;
    Contact4Name: string;
    Contact5Name: string;
}

export class MtmaExportRow {
    Type: string;
    Name: string;
    Description: string;
    Phone: string;
    UnitCode: string;
    KeypadTagCode: string;
    Action1: string;
    Action2: string;
    Group: string;
    Contact1: string;
    Contact2: string;
    Contact3: string;
    Contact4: string;
    Contact5: string;
}

export class MtmaUploadData {
    Data: MtmaExportData[];
    ImportContacts: boolean;
    ImportUnits: boolean;
    ImportKeypads: boolean;
    ImportTags: boolean;
}